<template>
  <div>
    <header class="section-header section-header--lg mt-3">
      <div>
        <h1 class="heading" qaid="registration-form-page-title" v-html="bp('completeRegistration')" />
      </div>
    </header>

    <p class="mb-3" qaid="registration-form-" v-html="bp('customerDetails')" />
    <div class="grid-x grid-margin-x">
      <div class="cell medium-6">
        <form
          id="powf_D049F6BE0307E51180EDC4346BAC6B34"
          ref="productRegistrationForm"
          :action="formActionUrl"
          method="post"
          qaid="registration-form"
          @submit.prevent="validateAndSubmit"
        >
          <fieldset class="max-w-sm">
            <input
              id="bike_description"
              v-model="selectedBike.description"
              name="powf_712c9c1e0507e51180edc4346bac6b34"
              type="hidden"
              qaid="registration-form-bikeDescription"
            />
            <input
              type="hidden"
              name="ignore_redirecturl"
              :value="`${originLocation}${contextPath}/bike-registration/confirmation`"
            />
            <input type="hidden" name="ignore_redirectmode" value="Auto" />
            <input
              id="trek_retailer"
              v-model="currentBikeShop"
              name="powf_fa347c3e0507e51180edc4346bac6b34"
              type="hidden"
              qaid="registration-form-currentBikeShop"
            />
            <!-- TRD docs used date instead of day for this field and the backend team rolled with it -->
            <input
              id="date"
              v-model="dayField"
              name="powf_2d0510ac6826e51180fefc15b428467c"
              type="hidden"
              qaid="registration-form-"
            />
            <input
              id="month"
              v-model="monthField"
              name="powf_eea35a8b6826e51180fefc15b428467c"
              type="hidden"
              qaid="registration-form-monthField"
            />
            <input
              id="year"
              v-model="yearField"
              name="powf_edb62ba07326e51180fefc15b428467c"
              type="hidden"
              qaid="registration-form-yearField"
            />
            <input
              id="validBikeJson"
              name="validBikeJson"
              type="hidden"
              qaid="registration-form-selectedBike"
              :value="JSON.stringify(selectedBike)"
            />

            <div id="purchase-date-field" class="form-group" :class="datePickerContainerClass">
              <label class="font-medium" v-html="bp('purchaseDate')" />
              <date-picker
                id="purchase-date-input"
                ref="purchaseDatePicker"
                class="mb-0"
                qaid="purchase-date-input"
                :allow-input="true"
                @input="setDatePicker"
                @blur="checkDatePicker"
              ></date-picker>
              <div v-if="datePickerContainerClass === 'has-error'" class="form-feedback is-invalid">
                The {{ bp('purchaseDate') }} field is required.
              </div>
            </div>

            <form-group
              id="serial_number"
              v-model="serialNumberField"
              v-validate="'required'"
              type="text"
              :data-vv-as="bp('serialNumber')"
              :error="bp('serialNumberError')"
              name="powf_8dd23d0a0507e51180edc4346bac6b34"
              :label="bp('serialNumber')"
              :show-error-messages="fieldHasError('powf_8dd23d0a0507e51180edc4346bac6b34')"
              qaid="registration-form-serial"
              @input="fieldHasError('powf_8dd23d0a0507e51180edc4346bac6b34')"
            ></form-group>

            <form-group
              id="first_name"
              v-model="firstNameField"
              v-validate="'required'"
              type="text"
              :data-vv-as="bp('firstName')"
              :error="bp('firstNameError')"
              name="powf_7bb97f180407e51180edc4346bac6b34"
              :label="bp('firstName')"
              qaid="registration-form-firstname"
              :show-error-messages="fieldHasError('powf_7bb97f180407e51180edc4346bac6b34')"
              @input="fieldHasError('powf_7bb97f180407e51180edc4346bac6b34')"
            ></form-group>

            <form-group
              id="last_name"
              v-model="lastNameField"
              v-validate="'required'"
              type="text"
              :data-vv-as="bp('surname')"
              :error="bp('lastNameError')"
              name="powf_de7989290407e51180edc4346bac6b34"
              :label="bp('surname')"
              :show-error-messages="fieldHasError('powf_de7989290407e51180edc4346bac6b34')"
              qaid="registration-form-surname"
              @input="fieldHasError('powf_de7989290407e51180edc4346bac6b34')"
            ></form-group>

            <form-group
              id="email"
              v-model="emailAddressField"
              v-validate="'required|email'"
              type="email"
              :data-vv-as="bp('emailAddress')"
              :error="bp('emailError')"
              name="powf_0582a1ca0407e51180edc4346bac6b34"
              :label="bp('emailAddress')"
              :show-error-messages="fieldHasError('powf_0582a1ca0407e51180edc4346bac6b34')"
              qaid="registration-form-email"
              @input="fieldHasError('powf_0582a1ca0407e51180edc4346bac6b34')"
            ></form-group>

            <form-group
              id="address"
              v-model="addressLine1Field"
              v-validate="'required'"
              type="text"
              :data-vv-as="bp('addressLine1')"
              :error="bp('addressError')"
              name="powf_6dc3c5410407e51180edc4346bac6b34"
              :label="bp('addressLine1')"
              :show-error-messages="fieldHasError('powf_6dc3c5410407e51180edc4346bac6b34')"
              qaid="registration-form-address"
              @input="fieldHasError('powf_6dc3c5410407e51180edc4346bac6b34')"
            ></form-group>

            <form-group
              id="address2"
              v-model="addressLine2Field"
              type="text"
              name="powf_4c2660560407e51180edc4346bac6b34"
              :label="bp('addressLine2')"
              qaid="registration-form-address2"
            ></form-group>

            <form-group
              id="city"
              v-model="townCityField"
              v-validate="'required'"
              type="text"
              name="powf_e55a95680407e51180edc4346bac6b34"
              :label="bp('townCity')"
              :data-vv-as="bp('townCity')"
              :error="bp('cityError')"
              :show-error-messages="fieldHasError('powf_e55a95680407e51180edc4346bac6b34')"
              qaid="registration-form-city"
              @input="fieldHasError('powf_e55a95680407e51180edc4346bac6b34')"
            ></form-group>

            <form-group
              id="state"
              v-model="stateField"
              v-validate="'required'"
              type="text"
              name="powf_9516e48a0407e51180edc4346bac6b34"
              :label="bp('selectState')"
              :data-vv-as="bp('selectState')"
              :error="bp('stateError')"
              :show-error-messages="fieldHasError('powf_9516e48a0407e51180edc4346bac6b34')"
              qaid="registration-form-state"
              @input="fieldHasError('powf_9516e48a0407e51180edc4346bac6b34')"
            ></form-group>

            <label for="select" class="form-label">{{ bp('country') }}</label>
            <div class="select mb-3">
              <select
                id="country"
                v-model="countryField"
                v-validate="'required'"
                name="powf_9ab9fa9c0407e51180edc4346bac6b34"
                qaid="tech-country-dropdown"
                class="form-control"
                :class="countriesContainerClass"
                @blur="checkCountryField"
              >
                <option
                  v-for="(country, index) in countriesList"
                  :key="index"
                  :value="country"
                  :disabled="index === 0"
                  >{{ country }}</option
                >
              </select>
            </div>

            <form-group
              id="zip"
              v-model="postalCodeField"
              v-validate="'required'"
              type="text"
              :data-vv-as="bp('postalcode')"
              :error="bp('zipError')"
              name="powf_caac28b30407e51180edc4346bac6b34"
              :label="bp('postalcode')"
              :show-error-messages="fieldHasError('powf_caac28b30407e51180edc4346bac6b34')"
              qaid="registration-form-postal"
              @input="fieldHasError('powf_caac28b30407e51180edc4346bac6b34')"
            ></form-group>

            <fieldset class="form-fieldset">
              <label class="checkbox">
                <input
                  id="opt_in"
                  v-model="optInVal"
                  type="checkbox"
                  true-value="true"
                  false-value="false"
                  name="opt_in"
                />
                <input id="optInValue" type="hidden" name="powf_f79fa5e10407e51180edc4346bac6b34" :value="optInVal" />
                <span class="control-indicator" qaid="registration-form-optin"></span>
                {{ bp('emailSignup') }}
              </label>
            </fieldset>
          </fieldset>
          <div class="buttons py-5">
            <trek-button primary type="submit" qaid="registration-form-submit">
              <span v-html="bp('registerBike')"></span>
            </trek-button>
            <trek-link button secondary href="/" qaid="registration-form-cancel">
              <span v-html="bp('cancel')"></span>
            </trek-link>
          </div>
        </form>
      </div>
      <div class="cell sm:hidden md:block medium-6">
        <img :src="selectedBike.imageUrl" qaid="registration-form-image" />
      </div>
    </div>
  </div>
</template>

<script>
import TrekButton from '@/components/TrekButton';
import TrekLink from '@/components/TrekLink';

export default {
  components: {TrekButton, TrekLink},
  props: {
    baseProperties: {
      type: Array,
      default: () => [],
    },
    selectedBike: {
      type: Object,
      default: () => ({}),
    },
    currentBikeShop: {
      type: String,
      default: '',
    },
    selectedBikeJson: {
      type: String,
      default: '',
    },
    countries: {
      type: Array,
      default: () => [],
    },
    contextPath: {
      type: String,
      default: '',
    },
    formActionUrl: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      serialNumberField: this.selectedBike.serialNumber,
      shopNameField: '',
      firstNameField: '',
      lastNameField: '',
      emailAddressField: '',
      phoneNumberField: '',
      addressLine1Field: '',
      addressLine2Field: '',
      townCityField: '',
      stateField: '',
      countryField: this.getBaseProperty('pleaseSelectText'),
      countriesList: [this.getBaseProperty('pleaseSelectText'), ...this.countries],
      dayField: '',
      monthField: '',
      yearField: '',
      purchaseDate: '',
      postalCodeField: '',
      datePickerContainerClass: '',
      countriesContainerClass: '',
      originLocation: window.location.origin,
      optInVal: 'false',
    };
  },

  methods: {
    setDatePicker({event}) {
      // Backend required day, month, and year to be provided in separate fields, hence usage of split
      if (event) this.purchaseDate = event;
      let splitDate = event.split('-');
      this.yearField = splitDate[0];
      this.monthField = splitDate[1];
      this.dayField = splitDate[2];
      this.datePickerContainerClass = '';
    },
    checkDatePicker() {
      if (this.purchaseDate === '') {
        this.datePickerContainerClass = 'has-error';
        return false;
      } else {
        this.datePickerContainerClass = '';
        return true;
      }
    },
    fieldHasError(nameOfField) {
      return !!this.$validator.errors.items.find((o) => o.field == nameOfField);
    },
    checkCountryField() {
      if (this.countryField === this.getBaseProperty('pleaseSelectText')) {
        this.countriesContainerClass = 'has-error';
        return false;
      } else {
        this.countriesContainerClass = '';
        return true;
      }
    },
    validateAndSubmit() {
      this.$validator.validateAll().then((result) => {
        this.checkCountryField(); // Make it 'red' if not selected
        if (this.checkDatePicker() && this.checkCountryField() && result) this.$refs.productRegistrationForm.submit();
      });
    },
  },
};
</script>
